/* file description */

import React, { FC, useState, useRef } from 'react';
import { Modal, Input, Form, Upload } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { AddOutline } from 'antd-mobile-icons';
import {
  getPolicy,
  policyUpload,
  upload,
} from '@/common/asset-apis/assetModel';
import { useSaveFile } from './effect';
import { UploadFileProps } from './type';
import {
  ModalLayout,
  ButtonLayout,
} from '@/asset/AssetTask/templates/Cascade/components';

const UploadButton: FC<UploadFileProps> = ({
  namespaceID,
  moduleID,
  moduleInfo,
  FetchAPI,
  reload,
  addEditRecord,
  mergeRowKey,
  fileConfig,
  isMobile,
}) => {
  const [uploadWrapVisible, setUploadWrap] = useState<boolean>(false);
  const uploadHost = useRef<string>('');
  const uploadUrl = useRef<string>('');
  const [form] = Form.useForm();
  const { saveFile } = useSaveFile({
    form,
    setUploadWrap,
    namespaceID,
    moduleID,
    moduleInfo,
    FetchAPI,
    reload,
    addEditRecord,
    mergeRowKey,
    uploadHost,
    uploadUrl: uploadUrl.current,
    fileConfig,
  });
  const [fileList, setList] = useState<any>([]);

  const normFile = (file: any) => {
    if (Array.isArray(file)) {
      return file;
    }
    setList(file?.fileList);
    return file?.fileList;
  };

  const handleUpload = (file: any) => {
    // // 获取签名
    // getPolicy(FetchAPI, file.file.name).then((res) => {
    //   const { xamzAlgorithm, xamzCredential, policy, xamzSignature, xamzDate, host } = res;
    //   uploadHost.current = host;
    //   const formData = new FormData();
    //   formData.append('key', file.file.name);
    //   formData.append('x-amz-algorithm', xamzAlgorithm);
    //   formData.append('x-amz-credential', xamzCredential);
    //   formData.append('policy', policy);
    //   formData.append('x-amz-signature', xamzSignature);
    //   formData.append('x-amz-date', xamzDate);
    //   formData.append('file', fileList[fileList.length - 1].originFileObj);
    //   // 上传文件
    //   policyUpload(FetchAPI, host, formData).then(() => {
    //     file.onProgress({ percent: 100 });
    //     file.onSuccess();
    //   });
    // });

    upload(FetchAPI, file).then((res) => {
      uploadUrl.current = res;
      file.onProgress({ percent: 100 });
      file.onSuccess();
    });
  };

  const closeUplaod = () => {
    setUploadWrap(false);
    form?.resetFields();
  };

  // const beforeUpload = (file:any) => {
  //   // 文件大小限制
  //   if (file.size > size) {
  //     message.error(`文件大小不能超过${size}`)
  //     return Upload.LIST_IGNORE
  //   }
  // }
  // if (!uploadWrapVisible) { return <></>; }
  return (
    <>
      <ModalLayout
        title="上传附件"
        width="600px"
        visible={uploadWrapVisible}
        onOk={saveFile}
        onCancel={closeUplaod}
        okText="保存"
        cancelText="取消"
        mobileHeight="40vh"
      >
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
        >
          <div style={{ padding: '0 80px 20px 80px' }}>
            <Form.Item
              name="file"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              noStyle
            >
              <Upload.Dragger
                name="files"
                // maxCount={1}
                // accept
                action="#"
                // beforeUpload={beforeUpload}
                customRequest={handleUpload}
              >
                <div
                  style={{
                    height: '40px',
                    background: 'rgba(1,100,200,0.1)',
                    margin: '30px 70px',
                    lineHeight: '40px',
                    color: '#0164C8',
                    fontSize: '14px',
                  }}
                >
                  {!isMobile ? (
                    <div>
                      {' '}
                      <CloudUploadOutlined /> 选择或拖拽上传文件
                    </div>
                  ) : (
                    <AddOutline fontSize={38} />
                  )}
                </div>
              </Upload.Dragger>
            </Form.Item>
          </div>
          <Form.Item label="备注" name="attachment_comment">
            <Input />
          </Form.Item>
        </Form>
      </ModalLayout>
      <ButtonLayout
        key="upload"
        onClick={() => {
          setUploadWrap(true);
        }}
      >
        上传附件
      </ButtonLayout>
    </>
  );
};
export default UploadButton;
